import React from "react";


import SpecialSantander from "../../common/SpecialSantander";
import EmptyArticle from "../../common/EmptyArticle";

const ASpecialSantander = props => {
    let article = EmptyArticle();
    const { settings } = props;
    article.link = settings.link;
    article.img = settings.img;
    article.title = settings.title;
    article.embed = settings.embed;
    article.description = settings.description;

    return (
        <div className={props.classes} {...props.events} >
            <SpecialSantander
                article={article}
                {...props}
            />
        </div>
    );
};


export default ASpecialSantander;
